module.exports = __webpack_public_path__ + "img/klassikt.5580fd2a.webp";